import React, { useState, useEffect } from 'react';
import { getBestItemImageUrl } from '../utils/imageUtils';

const SimpleImageTest = () => {
  const [imageState, setImageState] = useState({
    loading: true,
    error: false,
    src: null,
    logs: []
  });

  const addLog = (message) => {
    console.log(message);
    setImageState(prev => ({
      ...prev,
      logs: [...prev.logs, `${new Date().toLocaleTimeString()}: ${message}`]
    }));
  };

  useEffect(() => {
    // Use actual item data from database for testing
    const testItem = {
      id: 99, // Real item ID from database
      user_id: 3, // Real user ID from database
      image_url: 'https://storage.googleapis.com/clutterlogix-storage/images/3_1757547417_item_PXL_20240603_191537867.jpg'
    };
    
    const testUrl = getBestItemImageUrl(testItem);
    
    console.log('🧪 SimpleImageTest: Using optimized image URL:', testUrl);
    
    addLog('🔄 Starting image test...');
    
    const img = new Image();
    img.crossOrigin = "anonymous";
    
    img.onload = () => {
      addLog(`✅ Image loaded: ${testUrl}`);
      addLog(`   Size: ${img.naturalWidth}x${img.naturalHeight}`);
      setImageState(prev => ({
        ...prev,
        loading: false,
        error: false,
        src: testUrl
      }));
    };
    
    img.onerror = (error) => {
      addLog(`❌ Image failed: ${testUrl}`);
      addLog(`   Error: ${error.message || 'Unknown error'}`);
      setImageState(prev => ({
        ...prev,
        loading: false,
        error: true
      }));
    };
    
    addLog(`🔄 Loading: ${testUrl}`);
    img.src = testUrl;
    
  }, []);

  return (
    <div style={{ padding: '20px', border: '1px solid #ccc', margin: '20px' }}>
      <h3>Simple Image Test</h3>
      
      <div style={{ marginBottom: '20px' }}>
        <strong>Status:</strong> {imageState.loading ? 'Loading...' : imageState.error ? 'Error' : 'Loaded'}
      </div>
      
      {imageState.src && (
        <div style={{ marginBottom: '20px' }}>
          <img 
            src={imageState.src} 
            alt="Test" 
            style={{ 
              width: '200px', 
              height: '200px', 
              objectFit: 'cover',
              border: '2px solid #ddd'
            }}
            onLoad={() => addLog('🎯 IMG element onLoad fired')}
            onError={() => addLog('❌ IMG element onError fired')}
          />
        </div>
      )}
      
      <div style={{ marginBottom: '20px' }}>
        <h4>Test Logs:</h4>
        <div style={{ 
          backgroundColor: '#f5f5f5', 
          padding: '10px', 
          maxHeight: '200px', 
          overflow: 'auto',
          fontSize: '12px',
          fontFamily: 'monospace'
        }}>
          {imageState.logs.map((log, index) => (
            <div key={index}>{log}</div>
          ))}
        </div>
      </div>
      
      <div>
        <h4>Direct API Test:</h4>
        <img 
          src={(() => {
            const testItem = {
              id: 99,
              user_id: 3,
              image_url: 'https://storage.googleapis.com/clutterlogix-storage/images/3_1757547417_item_PXL_20240603_191537867.jpg'
            };
            const url = getBestItemImageUrl(testItem);
            console.log('🧪 Direct API test using:', url);
            return url;
          })()}
          alt="Direct API"
          style={{ 
            width: '100px', 
            height: '100px', 
            objectFit: 'cover',
            border: '2px solid #ddd'
          }}
          onLoad={() => addLog('🎯 Direct API image loaded')}
          onError={() => addLog('❌ Direct API image failed')}
        />
      </div>
    </div>
  );
};

export default SimpleImageTest;
